<template>
  <layout-basic>

      <h3 class="title is-4">Test types</h3>

      <a class="button is-primary " href="/test-types/new">
        Add new
      </a>
      <b-table
        :data="testTypes"
        :striped="true"
      >

        <b-table-column field="name" label="Name"  v-slot="props">
          {{ props.row.name }}
        </b-table-column>

        <b-table-column field="actions" v-slot="props" cell-class="has-text-right">
          <a class="button is-small is-info" :href="'/test-types/' + props.row._id + '/edit'">
            <b-icon icon="pencil-alt" size="is-small"></b-icon>
          </a>


          <button class="button is-small is-danger ml-2" @click="deleteTestType(props.row._id)">
            <b-icon icon="trash-alt" size="is-small"></b-icon>
          </button>
        </b-table-column>

        <template slot="empty">
          <p>No test types created, yet</p>
        </template>
      </b-table>

  </layout-basic>
</template>
<script>

import LayoutBasic from '@/layouts/LayoutBasic'
import TestTypeService from '@/services/TestTypeService'

export default {
  name: 'TestTypes',
  components: {
    LayoutBasic
  },
  created () {
    this.getTestTypesList();
  },
  data () {
    return {
      testTypes: [],
    }
  },

  methods: {
    getTestTypesList() {
      TestTypeService.getList().then((response) => {
        this.testTypes = response.data;
      }).catch((e) => {
        console.log(e);
      })
    },

    cardModal() {
      this.$buefy.modal.open({
        parent: this,
        component: NewTestTypeModal,
        hasModalCard: true,
        trapFocus: true,
      })
    },

    deleteTestType(projectId) {
      TestTypeService.delete(projectId).then(response => {
        this.getTestTypesList();
      })
    }
  }
}
</script>
